export const DATE_FIELDS = ['date_field', 'skan_postback_date', 'estimated_install_date'];

export const FIELD_SECTION = {
    FILTERS: 'Filters',
    DIMENSIONS: 'Dimensions',
    METRICS: 'Metrics',
    COHORT_DATA: 'Cohort Data',
    AUDITING: 'Auditing Fields',
    TIME_BREAKDOWNS: 'Time Breakdown',
    CHECKBOXES: 'Options',
    UNIFIED_DATA_TYPES: 'Unified Data Types',
    SKAN_DATE_TYPE: 'Date Type',
    SKAN_ADVANCED_ANALYTICS: 'SKAN Advanced Analytics',
    SKAN_BREAKDOWNS: 'SKAN Breakdowns',
    CROSS_DEVICE_ATTRIBUTION_TYPE: 'Attribution Type',
    SUPPORT: 'Support',
    OTHER: 'Other',
    AI_TAGS: 'AI tags',
};

export const NEW_SECTIONS = new Set([FIELD_SECTION.AI_TAGS]);

export const ANGULAR_ADMIN_MODE_CHANGED_EVENT = 'angularAdminModeChanged';

export const REGULAR_MODE = 'regular';
export const COMPARE_MODE = 'compare';

export const SECTIONS_BY_ORDER = [
    FIELD_SECTION.TIME_BREAKDOWNS,
    FIELD_SECTION.FILTERS,
    FIELD_SECTION.DIMENSIONS,
    FIELD_SECTION.AI_TAGS,
    FIELD_SECTION.METRICS,
    FIELD_SECTION.COHORT_DATA,
    FIELD_SECTION.AUDITING,
    FIELD_SECTION.CHECKBOXES,
    FIELD_SECTION.UNIFIED_DATA_TYPES,
    FIELD_SECTION.OTHER,
];

export const SELECTED_FIELDS_EXCLUDED_SECTIONS = [FIELD_SECTION.TIME_BREAKDOWNS, FIELD_SECTION.CHECKBOXES];

const UNIFIED_DISPLAY_NAME = 'Unified';
const TRACKER_DISPLAY_NAME = 'Tracker';
const SKAN_DISPLAY_NAME = 'SKAN';
const NETWORK_DISPLAY_NAME = 'Network';

export const UNIFIED_REPORT_TYPES = Object.freeze({
    PRE_INSTALL: 'pre_install',
    UNIFIED: 'unified',
    TRACKER: 'tracker',
    SKAN: 'skan',
    NETWORK: 'network',
});
export const SORTING_INDEX_MAP = {
    [UNIFIED_REPORT_TYPES.PRE_INSTALL]: 1,
    [UNIFIED_REPORT_TYPES.UNIFIED]: 2,
    [UNIFIED_REPORT_TYPES.TRACKER]: 3,
    [UNIFIED_REPORT_TYPES.SKAN]: 4,
    [UNIFIED_REPORT_TYPES.NETWORK]: 5,
};
export const SORTING_INDEX_TO_DISPLAY_NAME = {
    [SORTING_INDEX_MAP[UNIFIED_REPORT_TYPES.UNIFIED]]: UNIFIED_DISPLAY_NAME,
    [SORTING_INDEX_MAP[UNIFIED_REPORT_TYPES.TRACKER]]: TRACKER_DISPLAY_NAME,
    [SORTING_INDEX_MAP[UNIFIED_REPORT_TYPES.SKAN]]: SKAN_DISPLAY_NAME,
    [SORTING_INDEX_MAP[UNIFIED_REPORT_TYPES.NETWORK]]: NETWORK_DISPLAY_NAME,
};
export const UNIFIED_REPORT_TYPES_TO_DISPLAY_NAME = {
    [UNIFIED_REPORT_TYPES.UNIFIED]: UNIFIED_DISPLAY_NAME,
    [UNIFIED_REPORT_TYPES.TRACKER]: TRACKER_DISPLAY_NAME,
    [UNIFIED_REPORT_TYPES.SKAN]: SKAN_DISPLAY_NAME,
    [UNIFIED_REPORT_TYPES.NETWORK]: NETWORK_DISPLAY_NAME,
};

export const FIELD_SECTION_DATA = {
    [FIELD_SECTION.DIMENSIONS]: {
        label: 'STATIC.DIMENSIONS',
        icon: 'table-column',
    },
    [FIELD_SECTION.AI_TAGS]: {
        label: 'STATIC.AI_TAGS',
        icon: 'ai-line',
    },
    [FIELD_SECTION.METRICS]: {
        label: 'STATIC.METRICS',
        icon: 'table-row',
    },
    [FIELD_SECTION.COHORT_DATA]: {
        label: 'STATIC.COHORT_DATA',
        icon: 'vector-group-line',
    },
    [FIELD_SECTION.TIME_BREAKDOWNS]: {
        label: 'STATIC.TIME_BREAKDOWN',
        style: {
            flexDirection: 'row',
            minWidth: 'unset',
        },
    },
    [FIELD_SECTION.AUDITING]: {
        label: 'STATIC.AUDITING',
        icon: 'tool-line',
    },
    [FIELD_SECTION.UNIFIED_DATA_TYPES]: {
        style: {
            padding: '0',
            gap: '0',
        },
    },
    [FIELD_SECTION.SKAN_ADVANCED_ANALYTICS]: {
        label: 'STATIC.SKAN_ADVANCED_ANALYTICS',
    },
    [FIELD_SECTION.SKAN_BREAKDOWNS]: {
        label: 'STATIC.SKAN_BREAKDOWNS',
    },
    [FIELD_SECTION.SUPPORT]: {
        label: 'STATIC.SUPPORT',
    },
    [FIELD_SECTION.OTHER]: {
        style: {
            backgroundColor: 'var(--gray50)',
            border: 'none',
            padding: '0',
            borderRadius: '0',
        },
    },
};
